import React from 'react';
import Link from '../links/Link';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { buildMailtoSupportUrl } from '../../utils/supportLinks';

interface IProps {
    errorCode?: string
}

const ErrorSupportLink: React.FC<IProps> = ({errorCode}: IProps) => {
    const { t } = useTranslation();

    const subject = `AttoConnect Support ${moment().toISOString()}${errorCode ? `, error code: ${errorCode}` : ''}`;

    return (
      <Link href={buildMailtoSupportUrl(subject, errorCode)} target="_blank">{t<string>('support team')}</Link>
    );
};

export default ErrorSupportLink;
